import React, { Component, useContext } from "react";
import ReactDOM from 'react-dom';
import axios from "axios"
import Pagination from "./Pagination";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class MyDossiersPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      maxRecords: 10,
      page: 1,
      searchActive: false,
      pagination: { page: 1 },
      dossiers: { data: [], total: 0 },
      selectedDossier: null,
      selectedDossierPath: null,
      active: false,
    };
  }

  getDossiers = async () => {
    const { page, maxRecords } = this.state;
    const request = await axios.get('/api/my_dossiers?page=' + page + '&maxRecords=' + maxRecords)
    this.setState({ dossiers: request.data })
  }

  getFilteredFiles = async () => {
    const { filters } = this.state;
    const mixFilter = {
      ...filters,
    }
    const query = new URLSearchParams();
    Object.keys(mixFilter).forEach(key => {
      if(mixFilter[key] != "" && mixFilter[key] != 1){
        query.append(key, mixFilter[key])
      }
    });
    const qs = query.toString()
    if(qs !== ""){
      const request = await axios.get(`/api/my_dossiers?${qs}`)
      this.setState({ dossiers: request.data, searchActive: true })
    } else {
      this.setState({ searchActive: false })
      this.getDossiers()
    }
  }

  handleFiltering = (e) => {
    this.setState((prev) => ({ filters: { ...prev.filters, [e.target.name]: e.target.value } }))
  }

  updateCurrentPage = (tab, page) => {
    this.setState((prev) => ({ page: tab, pagination: { ...prev.pagination, page } }))
  }

  componentDidMount() {
    this.getDossiers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters || prevState.pagination.page !== this.state.pagination.page) {
      this.getFilteredFiles();
    }
  }

  invitationDialog = (id, path) => {
    this.setState({ selectedDossier: id, selectedDossierPath: path });
    $('#modal-invitation').modal('show');
    $('#message').removeClass('is-invalid');

    setTimeout(function(){
      $('#message').focus();
    }, 600)
  }

  copyLink = (link) => {
    navigator.clipboard.writeText(link);
    toastr.info("Link copiado");
  }

  sendInvitation = async() => {
    const { selectedDossier } = this.state;
    const params = JSON.stringify({
      id: selectedDossier,
      emails: $('#emails').val(),
      message: $('#message').val(),
    })

    await axios.post(
      '/api/my_dossiers/invitation',
      params,
      {
        "headers": {
            "content-type": "application/json",
        },
      }
    ).then((response) => {
      window.unblockUI();
      $('#modal-invitation').modal('hide');

      swal.fire({
        text: getSuccessMessage(response),
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn font-weight-bold btn-primary"
        },
        timer: 3000
      }).then(function(result) {
      });
    })
    .catch((error) => {
      window.unblockUI();
      const message = getErrorsMessage(error);
      if (this.state.active) {
        KTUtil.btnRelease(KTUtil.getById('btnPublish'));
      } else {
        KTUtil.btnRelease(KTUtil.getById('btnSave'));
      }

      swal.fire({
        text: message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Aceptar",
        customClass: {
            confirmButton: "btn font-weight-bold btn-primary"
        }
      }).then(function() {
        KTUtil.scrollTop();
      });
    });
  }

  render() {
    const { lang } = this.context;
    const { dossiers_url } = this.props;
    const { dossiers, page } = this.state;
    return (
    <>
      <div className="row">
        <div className="col-8">
        </div>

        <div className="col-4">
          <div className="input-icon">
            <input
              onChange={this.handleFiltering}
              name="search"
              type="text"
              className="form-control"
              placeholder={lang.get('messages.buscar_documentos')} />
            <span>
              <i className="flaticon2-search-1 text-primary icon-md"></i>
            </span>
          </div>
        </div>
      </div>

      <h5 className="text-dark font-weight-bold my-5">
        <small className="text-muted font-weight-bold">{lang.get('messages.resultados_de_la_busqueda')}:</small>
        &nbsp; {dossiers.total} &nbsp;
        <small className="text-muted font-weight-bold">{lang.get('messages.expedientes_encontrados')}</small>
      </h5>

      <div className="card card-custom gutter-b my-5">
        <div className="card-body">
          <div className="table table-borderless table-vertical-center table-responsive">
            { dossiers.data.map((dossier, i) => {
              return <div key={i}>
                <div className="d-flex align-items-center py-2">
                  <div className="symbol symbol-40">
                    <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                      {dossier.title[0]}
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-grow-1 my-lg-0 m-2">
                    <a href={"/my_dossiers/" + dossier.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"}>
                      {dossier.title}
                    </a>
                    <span className="font-size-xs text-muted">{dossier.files.length} {lang.get('messages.documentos_en_el_expediente')}</span>
                  </div>
                  <a title="Compartir invitación" onClick={() => this.invitationDialog(dossier.id, dossier.path)} className="mr-6">
                    <button className="btn btn-icon btn-light btn-xs">
                      <i className={"flaticon2-reply icon-sm text-primary"}></i>
                    </button>
                  </a>
                  <a title="Descargar" href={"/my_dossiers/" + dossier.id + "/edit"}>
                    <button className="btn btn-icon btn-light btn-xs">
                      <i className={"flaticon2-right-arrow icon-sm text-primary"}></i>
                    </button>
                  </a>
                </div>
              </div>
              })
            }
          </div>

          {dossiers.total > 10 &&
            <SimplePagination
              updateCurrentPage={this.updateCurrentPage}
              currentPage={page}
              totalFiles={dossiers.total}
              split={10} />
          }
        </div>
      </div>

      <div className="modal fade" id="modal-invitation" tabIndex="-1" role="dialog" aria-labelledby="modal-invitationLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal-invitationLabel">Enviar invitación</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <i aria-hidden="true" className="ki ki-close"></i>
              </button>
            </div>
            <div className="modal-body">
              <input placeholder="Emails" id="emails" className="form-control form-control-solid required"></input>
              <div className="invalid-feedback">Campo requerido.</div>
            </div>
            <div className="modal-body">
              <textarea placeholder="Mensaje" id="message" className="form-control form-control-solid required" rows="6"></textarea>
              <div className="invalid-feedback">Campo requerido.</div>
            </div>
            <div className="modal-body">
              <span>Link: <a href={dossiers_url + this.state.selectedDossierPath}>{dossiers_url + this.state.selectedDossierPath}</a></span>
              <a title="Copiar" className="ml-4" onClick={() => this.copyLink(dossiers_url + this.state.selectedDossierPath)}>
                <button className="btn btn-icon btn-light btn-xs">
                  <i className={"flaticon2-copy icon-sm text-primary"}></i>
                </button>
              </a>
            </div>
            <div className="modal-footer">
              <a onClick={this.sendInvitation} className="btn btn-primary">
                Enviar
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
  }
}

export default MyDossiersPanel;

if (document.getElementById('MyDossiersPanel')) {
  ReactDOM.render(<MyDossiersPanel />, document.getElementById('MyDossiersPanel'));
}

